import { useTranslation } from "react-i18next";
import { EP_Card, EP_Container, EP_Description, EP_Icon, EP_Item, EP_Items, EP_Title } from "./EmptyGoods.styled";
import { Music2, PackageSearch, Sparkles } from "lucide-react";

interface EmptyGoodsProps {}

export const EmptyGoods = ({}: EmptyGoodsProps) => {
	const { t } = useTranslation();

	return (
		<EP_Container>
			<EP_Card>
				<EP_Icon>
					<PackageSearch size={54} strokeWidth={1.5} />
				</EP_Icon>
				<EP_Title>{t("emptyProducts.title")}</EP_Title>
				<EP_Description>{t("emptyProducts.description")}</EP_Description>
				<EP_Items>
					<EP_Item>
						<Music2 size={18} />
						{t("emptyProducts.items.courses")}
					</EP_Item>
					<EP_Item>
						<Sparkles size={18} />
						{t("emptyProducts.items.materials")}
					</EP_Item>
				</EP_Items>
			</EP_Card>
		</EP_Container>
	);
};
